/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';
import can from 'can/util/util';
import _ from 'lodash';

export default Construct.extend({
    getAbsoluteURL: function(link) {
        const a = document.createElement('a');
        a.href = link;
        return a.protocol + '//' + a.host + a.pathname;
    },
    getEncodedUrl: function () {
        var location = window.location;
        return window.encodeURIComponent(location.protocol + '//'
            + location.host + location.pathname + location.hash);
    },
    pushState(url, title = null, state = null){
        const hasPushstate = window.history && window.history.pushState;
        if (hasPushstate) {
            try {
                window.history.pushState(state, title, url);
            } catch (err) {
                console.log(err);
            }
        }
    },
    replaceState(url, title = null, state = null){
        const hasReplaceState = window.history && window.history.replaceState;
        if (hasReplaceState) {
            try {
                window.history.replaceState(state, title, url);
            } catch (err) {
                console.log(err);
            }
        }
    },

    setHash (hash) {
        location.hash = hash;
    },

    getHash: function () {
        return window.location.hash;
    },

    getHashValue(key) {
        const matches = window.location.hash.match(new RegExp(key+'=([^&]*)'));
        return matches ? matches[1] : null;
    },

    onLocationHashChanged(cb) {
        return window.addEventListener("hashchange", cb, false);
    },

    removeHash(){
        location.hash = "";
    },

    getBaseUrl: function () {
        return location.protocol + '//' + location.host;
    },
    getUrl: function () {
        return location.protocol + '//' + location.host + location.pathname;
    },
    getUrlFromPagePath: function (pagePath, hasHash) {
        let url = '';
        if (/^(http:|https:|usopen:)\/\//i.test(pagePath)) {
            url = pagePath;
        } else {
            url += pagePath ?
                this.getBaseUrl() + ('/' + pagePath).replace(/\/+/, '/').replace(/\/+$/, '') :
                this.getUrl();
            url += hasHash ? window.location.hash : '';
        }
        return url;
    },
    getPathName: function () {
        return location.pathname;
    },
    getHostName: function () {
        return location.hostname;
    },
    getFeedUrlFromContext: function (context) {
        var path = context.page || context.feed;
        path = path || (context.path && context.path.replace(/^(\/[^\/]+)\/*.*$/, '$1'));
        path = path || '/en';

        return location.protocol + '//' + location.host + '/' + _.trim(path, ' /');
    },
    getPageUrlFromContext: function (context) {
        var path = context.path || location.pathname || '/en';

        return location.protocol + '//' + location.host + '/' + _.trim(path, ' /');
    },
    applyUrlParams: function (url, params) {
        return can.sub(url, params);
    },
    getQueryVariables: function () {
        var href = window.location.href;
        var queryStart = href.indexOf('?') + 1;
        var queryEnd = href.indexOf('#');
        return can.deparam(href.slice(queryStart, queryEnd < 0 ? href.length : queryEnd));
    },
    isFullPath: function (path) {
        return /^(\/\/|http)/.test(path);
    },
    // eslint-disable-next-line
    updateQueryString: function (key, value, url) { /* this function is duplicated in /src/helpers/url.js */
        var re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi');
        var hash;

        if (!url || !_.isString(url)) {
            url = '';
        }

        if (re.test(url)) {
            if (typeof value !== 'undefined' && value !== null) {
                return url.replace(re, '$1' + key + '=' + value + '$2$3');
            } else {
                hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                    url += '#' + hash[1];
                }
                return url;
            }
        } else if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        } else {
            return url;
        }
    }
}, {
    /* */
});
